import styled from 'styled-components';
import { useState } from 'react';
import { Lang, LangValues } from '../type';

const FlagsContainer = styled.div`
  position: relative;
`;
const Flag = styled.img`
  display: block;
  width: ${(props) => `4${props.theme.unit}`};
`;
const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  margin-top: ${(props) => `0.6${props.theme.unit}`};
  display: flex;
  flex-direction: column;
  gap: ${(props) => `0.6${props.theme.unit}`};
`;
const FlagPick = styled.button`
  display: block;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  border: 0.3vmin solid #000;
  border-radius: 50%;
  box-shadow: 0 0.3vmin rgba(0, 0, 0, 0.3);
`;

export const Flags = ({
  lang,
  onClick,
}: {
  lang: LangValues;
  onClick: (lang: LangValues) => void;
}) => {
  const [dropdown, setDropdown] = useState<boolean>(false);

  return (
    <FlagsContainer>
      <FlagPick
        onClick={() => {
          setDropdown((v) => !v);
        }}
      >
        <Flag
          src={`${process.env.PUBLIC_URL}/images/flags/${lang}.webp`}
          alt={lang}
        />
      </FlagPick>
      {dropdown && (
        <Dropdown>
          {Object.values(Lang).map((l) => {
            if (l === lang) return;
            return (
              <FlagPick
                key={l}
                onClick={() => {
                  onClick(l);
                  setDropdown(false);
                }}
              >
                <Flag
                  src={`${process.env.PUBLIC_URL}/images/flags/${l}.webp`}
                  alt={l}
                />
              </FlagPick>
            );
          })}
        </Dropdown>
      )}
    </FlagsContainer>
  );
};
